import { Container, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { useMsal } from '@azure/msal-react';
import './NavBar.css'

const Navbar = () => {

    const { instance } = useMsal();

    const handleSignOut = () => {
        instance.logoutRedirect();
    };    

    const navItemStyle = {
        color: '#ffffff',
        padding: "0px"
    }

    const navBarStyle = {
        backgroundColor: '#a73c21',
        //padding: "0px",
        //height: "6vh",
        //minHeight: "6vh",
        height: '40px',
        flexShrink: 0
    }

    return (
        <Container fluid style={navBarStyle} className="mb-3">
            <Container style={navBarStyle}>
            <Row style={navBarStyle}>
                <Col xs={4} className="d-flex">
                    <Link to="/" className="navbar" style={navItemStyle}>Campaigns</Link>
                    <Link to="/products" className="navbar" style={navItemStyle}>Products</Link>
                    <Link to="/brands" className="navbar" style={navItemStyle}>Brands</Link>
                    <span style={{color: '#ffffff', margin: '0 10px', display: 'flex', alignItems: 'center'}}>|</span>
                    <Link to="/promos" className="navbar" style={navItemStyle}>Promos</Link>
                </Col>
                <Col s={1} xs={1} className='d-flex text-end offset-7'>
                    <button onClick={handleSignOut} className='text-end align-items-center sign_out' style={{...navItemStyle, background: 'none', border: 'none', cursor: 'pointer'}}>Sign Out</button>
                </Col>
            </Row>
            </Container>
            
        </Container>
    );
}
 
export default Navbar;